import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"

import { fbAuth } from "../../services/Firebase"
import { MdFavoriteBorder } from "react-icons/md"
import { useFavorite } from "../../contexts/FavoriteContext"
import Service from "../../services/Service"

function WineSlide({ wine, displayPage, favWine, setFavWine }) {
    const history = useHistory()
    const allowFavorite = useFavorite()
    const [ wineIds, setWineIds ] = useState([])
    let user = {}

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }

    useEffect(() => {
        const noDups = [ ...new Set(favWine) ]
        Service.storeData( `${user.uid}-wine`, noDups )
    }, [ favWine, wineIds, user.uid ])

    const handleRouteWine = () => {
        history.push( `/wine/${wine.id}` )
        displayPage()
    }

    const handleFavorite = () => {
        setFavWine([ ...favWine, wine ])
        setWineIds([ ...wineIds, wine.id ])
        console.log("Added to Favorite")
    }

    const handleTouch = (e) => e.target.classList.add( "active" )
    
    return (
        <>
            <section>
                { allowFavorite
                    &&  <button className="favorite" onClick={handleFavorite} onTouchStart={handleTouch}>
                        <MdFavoriteBorder size="22.5px"/>
                    </button> 
                }
                <h3>{wine.title}</h3> 
            </section>
            <section className="wineSlide" onClick={handleRouteWine}>
                <img src={wine.imageURL} alt="Wine" />
            </section>
        </>
    )
}

export default WineSlide
